import { render, staticRenderFns } from "./RightSideMenu.vue?vue&type=template&id=726f1901&scoped=true&"
import script from "./RightSideMenu.vue?vue&type=script&lang=js&"
export * from "./RightSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f1901",
  null
  
)

export default component.exports